module.exports = __webpack_public_path__ + "img/nlsbasic.ebfa7bf0.jpg";